import React, { useState } from "react";
import Context from "./Index";
import { NotesApi, SUCCESS_API_RESPONSE } from "../../../Shared/Constants/api";
import {
  errorDeleteingData,
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  genericError,
  ItemCreated,
  ItemUpdated,
  successDeleted,
} from "../../../Shared/Constants";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils";
import { alertError, alertSuccess } from "../../../Shared/Utils/alertMessages";
import { getCall } from "../../../Shared/Api/GetApi";
import { putCall } from "../../../Shared/Api/PutApi";
import { deleteCall } from "../../../Shared/Api/DeleteApi";
import { noteCreationPayload, noteUpdatePayload } from "../Data/NoteWrappers";
import { postCall } from "../../../Shared/Api/PostApi";
import { MODEL_TYPE_ENUM } from "../../../Shared/Constants/enums";
export default function NoteProvider(props) {
  const [showModal, setShowModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [firstId, setFirstId] = useState();
  const [lastId, setLastId] = useState();
  const modalTogle = () => {
    setShowModal(!showModal);
  };

  const [items, setItems] = useState([]);
  const [item, setItem] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [index, setIndex] = useState(0); //el index de la nota que tengo renderizada en el modal
  const [nextId, setNextId] = useState();
  const [previousId, setPreviousId] = useState();
  /**
   * Get a list of items
   * @param {*} page
   * @param {*} limit
   */
  const fetchItems = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getCall(NotesApi, {
        page: page,
        limit: limit,
        ...filters,
      });
      let data = response.data;
      if (response.result === SUCCESS_API_RESPONSE) {
        setItems((prevItems) => [...prevItems, ...data?.items]);
        //setTotalRows(items.length + data.items.length);
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTotalRows(0);
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Get one note data
   * @param {*} id
   */
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await getCall(`${NotesApi}/${id}`);
      let data = response.data;
      if (response.result === SUCCESS_API_RESPONSE) {
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Create a item
   * @param {*} data
   */
  const createItem = async (data) => {
    setSaving(true);
    try {
      let response = await postCall(NotesApi, noteCreationPayload(data));

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        setItems([]);
        setCurrentPage(1);
        fetchItems(currentPage, rowsPerPage);
        alertSuccess(ItemCreated);
        modalTogle();
        setItem({});
      } else {
        alertToastErrorFromResponse(errorInsertingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  /**
   * Update a item
   * @param {*} data
   * @param {*} id
   */
  const updateItem = async (data, id) => {
    setSaving(true);
    try {
      let response = await putCall(
        `${NotesApi}/${id}`,
        noteUpdatePayload(data)
      );

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        // Actualizar el estado `items` con los nuevos datos

        setItems((prevItems) =>
          prevItems.map((item) =>
            item.id === id ? { ...item, ...data } : item
          )
        );
        alertSuccess(ItemUpdated);
        modalTogle();
      } else {
        alertToastErrorFromResponse(errorUpdatingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  /**
   * Delte a item
   * @param {*} id
   */
  const deleteItem = async (id) => {
    setSaving(true);
    try {
      let response = await deleteCall(`${NotesApi}/${id}`, id);

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        const newdata = items.filter((elem) => {
          return id !== elem.id;
        });
        setItems(newdata);
        alertSuccess(successDeleted);
      } else {
        alertToastErrorFromResponse(errorDeleteingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  const getNextNote = async (contact_id) => {
    let response = await getCall(`${NotesApi}/${contact_id}/next/${item.id}`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setNextId(response.data);
    }
  };

  const getPreviousNote = async (contact_id) => {
    let response = await getCall(
      `${NotesApi}/${contact_id}/previous/${item.id}`
    );
    if (response.result === SUCCESS_API_RESPONSE) {
      setPreviousId(response.data);
    }
  };

  const fetchFirstId = async (contact_id) => {
    try {
      let response = await getCall(`${NotesApi}/${contact_id}/first`, {
        model_type: MODEL_TYPE_ENUM.CONTACT,
        ...filters,
      });
      if (response.result === SUCCESS_API_RESPONSE) {
        setFirstId(response.data);
      } else {
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    }
  };

  const fetchLastId = async (contact_id) => {
    try {
      let response = await getCall(`${NotesApi}/${contact_id}/last`, {
        model_type: MODEL_TYPE_ENUM.CONTACT,
        ...filters,
      });
      if (response.result === SUCCESS_API_RESPONSE) {
        setLastId(response.data);
      } else {
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        fetchItems,
        items,
        rowsPerPage,
        currentPage,
        setCurrentPage,
        createItem,
        updateItem,
        deleteItem,
        item,
        loading,
        saving,
        showModal,
        modalTogle,
        setShowModal,
        setFilters,
        filters,
        setItems,
        totalRows,
        readOnly,
        setReadOnly,
        setItem,
        getItem,
        isAdding,
        setIsAdding,
        index,
        setIndex,
        fetchFirstId,
        fetchLastId,
        nextId,
        previousId,
        getNextNote,
        getPreviousNote,
        firstId,
        lastId,
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
